module.exports = __webpack_public_path__ + "assets/202509252035/img/Alex.27c02955.jpg";